document.addEventListener("DOMContentLoaded", function () {
    const appKey = "kXK2MsK90GqNNn4VIRzpbuemME0g7Glc8mw8DvoR";
    let page = 1;
    const perPage = 5;
    let bottomline = [];
    let reviews = [];
    let topicsList = [];
    let selectedTopics = [];
    let filteredReviews = []; 
    let starDistribution;
const section = document.querySelector('#yotpoReviewsApi');

const raw = section.getAttribute('buffy-bundle-products') || '';

const productIds = raw
  .split(',')          // split on commas
  .map(id => id.trim()) // remove spaces
  .filter(id => id)     // remove empty values
  .map(id => Number(id)); // convert to numbers (optional)

console.log(productIds);


    async function fetchBottomline() {
         console.log('running bottom line logic');
      try {
        const allBottomlines = await Promise.all(
          productIds.map(id =>
            fetch(`https://api-cdn.yotpo.com/products/${appKey}/${id}/bottomline`)
              .then(res => res.json())
              .then(data => data.response.bottomline)
          )
        );
        // Combine bottomlines
        bottomline = combineBottomlines(allBottomlines);
        displayBottomline(bottomline);
      } catch (error) {
        console.error("Error fetching bottomlines:", error);
      }
    }
    
    function combineBottomlines(bottomlines) {
      const totalReviews = bottomlines.reduce((sum, bl) => sum + (bl.total_reviews || 0), 0);
      const totalScore = bottomlines.reduce((sum, bl) => sum + (bl.average_score * (bl.total_reviews || 0)), 0);
      const averageScore = totalReviews ? (totalScore / totalReviews).toFixed(2) : 0;
    
      return { total_reviews: totalReviews, average_score: averageScore };
    }
    
    function displayBottomline(bottomline) {
        console.log('my bottom line is ' , bottomline);
        const averageScore = document.querySelector(".ytp-ave-score");
        const starRating = document.querySelectorAll(".ytp-star-rating");
        const totalReviews = document.querySelectorAll(".ytp-total-reviews");
        averageScore.innerText = Number(bottomline.average_score).toFixed(1);
        totalReviews.forEach(item => {
            item.innerText = bottomline.total_reviews.toLocaleString();
        });
        starRating.forEach(item => {
            item.innerHTML = generateStarRating(bottomline.average_score);
        });
    }

    async function fetchTopics() {
      try {
        const allTopics = await Promise.all(
          productIds.map(id => {
            return fetch(`https://api-cdn.yotpo.com/v1/topic/${appKey}/topics.json`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ domain_key: id })
            })
              .then(res => res.json())
              .then(data => data.top_topics?.top_mention_topics || []);
          })
        );
    
        // Flatten and de-duplicate by topic name
        const topicMap = {};
        allTopics.flat().forEach(t => {
          topicMap[t.name] = t;
        });
        topicsList = Object.values(topicMap);
        displayTopicButtons();
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    }
    

    function displayTopicButtons() {
        const container = document.getElementById("ytpTopicButtons");
        container.innerHTML = "";
    
        const isMobile = window.innerWidth < 768;
        const maxButtons = isMobile ? 3 : 6;
    
        topicsList.forEach((topic, index) => {
            const button = document.createElement("button");
            button.className = "topic-button";
            button.textContent = topic.name;
            button.onclick = () => toggleTopicFilter(topic.name, button);
            if (index < maxButtons) {
                container.appendChild(button);
            } else {
                button.style.display = "none"; // Hide extra buttons initially
                container.appendChild(button);
            }
        });
    
        if (topicsList.length > maxButtons) {
            const showMoreButton = document.createElement("button");
            showMoreButton.className = "show-more-button";
            showMoreButton.textContent = "Show More";
            showMoreButton.onclick = () => {
                const buttons = container.querySelectorAll(".topic-button");
                const isExpanded = showMoreButton.textContent === "Show Less";
                buttons.forEach((btn, index) => {
                    if (index >= maxButtons) {
                        btn.style.display = isExpanded ? "none" : "inline-block";
                    }
                });
                showMoreButton.textContent = isExpanded ? "Show More" : "Show Less";
            };
            container.appendChild(showMoreButton);
        }
    }
      window.addEventListener("resize", displayTopicButtons); // Recalculate buttons on resize
    
    function toggleTopicFilter(topic, button) {
        if (selectedTopics.includes(topic)) {
            // If topic is already selected, remove it
            selectedTopics = selectedTopics.filter(t => t !== topic);
            button.classList.remove("active");
        } else {
            // Add topic to the selected list
            selectedTopics.push(topic);
            button.classList.add("active");
        }
        applyFilters(null, false);
    }

    async function fetchReviews(initialLoad = false) {
      try {
        const allReviewData = await Promise.all(
          productIds.map(id =>
            fetch(`https://api-cdn.yotpo.com/v1/widget/${appKey}/products/${id}/reviews.json?per_page=5&page=1`)
              .then(res => res.json())
              .then(data => data.response)
          )
        );
        
        reviews = allReviewData.flatMap(res => res.reviews || []);
        starDistribution = combineStarDistributions(allReviewData.map(r => r.bottomline?.star_distribution));
        applyFilters(null, initialLoad);
    
        if (starDistribution) {
          displayStarDistribution(starDistribution);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    }
    
    function combineStarDistributions(distributions) {
      const combined = { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0 };
      distributions.forEach(dist => {
        if (dist) {
          for (let i = 1; i <= 5; i++) {
            combined[i] += parseInt(dist[i] || 0);
          }
        }
      });
      return combined;
    }
    

    async function fetchReviewsByStar(rating) {
        let url = `https://api-cdn.yotpo.com/v1/widget/${appKey}/products/${productId}/reviews.json?star=${rating}`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", "Accept": "application/json" }
            });

            const data = await response.json();
            return data.response.reviews || [];
            
        } catch (error) {
            console.error("Error fetching reviews by star:", error);
            return [];
        }
    }

    async function displayStarDistribution(starDistribution) {
        const ytpStar5 = document.querySelectorAll('.ytp-star-distribution .ytp-star-5');
        const ytpStar4 = document.querySelectorAll('.ytp-star-distribution .ytp-star-4');
        const ytpStar3 = document.querySelectorAll('.ytp-star-distribution .ytp-star-3');
        const ytpStar2 = document.querySelectorAll('.ytp-star-distribution .ytp-star-2');
        const ytpStar1 = document.querySelectorAll('.ytp-star-distribution .ytp-star-1');

        const progressBar5 = document.querySelectorAll('.ytp-star-item[data-star="5"] .ytp-progress-bar-score');
        const progressBar4 = document.querySelectorAll('.ytp-star-item[data-star="4"] .ytp-progress-bar-score');
        const progressBar3 = document.querySelectorAll('.ytp-star-item[data-star="3"] .ytp-progress-bar-score');
        const progressBar2 = document.querySelectorAll('.ytp-star-item[data-star="2"] .ytp-progress-bar-score');
        const progressBar1 = document.querySelectorAll('.ytp-star-item[data-star="1"] .ytp-progress-bar-score');
        
        ytpStar5.forEach(el => {
          el.innerText = starDistribution['5'];
        });
        ytpStar4.forEach(el => {
          el.innerText = starDistribution['4'];
        });
        ytpStar3.forEach(el => {
          el.innerText = starDistribution['3'];
        });
        ytpStar2.forEach(el => {
          el.innerText = starDistribution['2'];
        });
        ytpStar1.forEach(el => {
          el.innerText = starDistribution['1'];
        });

        progressBar5.forEach(el => {
          el.style.width = `${(parseInt(starDistribution['5']) / parseInt(bottomline.total_reviews)) * 100}%`;
        });
        progressBar4.forEach(el => {
          el.style.width = `${(parseInt(starDistribution['4']) / parseInt(bottomline.total_reviews)) * 100}%`;
        });
        progressBar3.forEach(el => {
          el.style.width = `${(parseInt(starDistribution['3']) / parseInt(bottomline.total_reviews)) * 100}%`;
        });
        progressBar2.forEach(el => {
          el.style.width = `${(parseInt(starDistribution['2']) / parseInt(bottomline.total_reviews)) * 100}%`;
        });
        progressBar1.forEach(el => {
          el.style.width = `${(parseInt(starDistribution['1']) / parseInt(bottomline.total_reviews)) * 100}%`;
        });
    }

    async function filterReviews(product_id = null, topics, rating, sortings, initialLoad = false) {
      try {
        const allFiltered = await Promise.all(
          productIds.map(id => {

            let bodyObject = {
              topic_names: topics,
              scores: rating,
              sortings: sortings
            };

            if(product_id && product_id != 'all') {
              bodyObject.domain_key = product_id;
            }
            else {
              bodyObject.domain_key = id;
            }

            let body = JSON.stringify(bodyObject);

            return fetch(`https://api-cdn.yotpo.com/v1/reviews/${appKey}/filter.json?per_page=5&page=1`, {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body
            })
              .then(res => res.json())
              .then(data => data.response.reviews || []);
          })
        );

        if(initialLoad) {
          const mergedSortedReviews = allFiltered.flat().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          return mergedSortedReviews;
        }
        else {
          return allFiltered.flat();
        }

      } catch (error) {
        console.error("Error filtering reviews:", error);
        return [];
      }
    }
  
    async function applyFilters(score = null, initialLoad = false) {
        //const product_id = document.getElementById("ytpProductFilter").value;
        const sortDdl = document.getElementById("ytpSort");
        const sortValue = sortDdl.value;
        const selectedOption = sortDdl.options[sortDdl.selectedIndex];
        const sortAsc = selectedOption.getAttribute("data-ascending");
        let ratingFilter = score;
        let sortings = [{
            "sort_by": 'date',
            "ascending": false
        }];

        if(!score) {
            ratingFilter = document.getElementById("ytpRating").value;
        }

        filteredReviews = [...reviews];

        if(sortValue) {
            sortings = [{
                "sort_by": sortValue,
                "ascending": sortAsc === 'false' ? false : (sortAsc === 'true' ? true : false)
            }];
        }
        if (ratingFilter) {
            const rating = parseInt(ratingFilter);
            let star_ratings;
            if(rating === 'all') {
                star_ratings = [5,4,3,2,1];
            }
            else if (!isNaN(rating)) {
                star_ratings = [rating];
            }

            if (selectedTopics.length > 0) {
              if (isNaN(rating)) {
                  star_ratings = [5,4];
                  sortings = [{
                    //"sort_by": 'score',
                    "sort_by": 'date',
                    "ascending": false
                  }];
                  //filteredReviews = await filterReviews(product_id, selectedTopics, star_ratings, sortings, initialLoad);
                  filteredReviews = await filterReviews(null, selectedTopics, star_ratings, sortings, initialLoad);
                  document.getElementById("ytpRating").value = "all";
                  document.getElementById("ytpSort").value = "date";
                }
                //filteredReviews = await filterReviews(product_id, selectedTopics, star_ratings, sortings, initialLoad);
                filteredReviews = await filterReviews(null, selectedTopics, star_ratings, sortings, initialLoad);
            }
            else {
                //filteredReviews = await filterReviews(product_id, [], star_ratings, sortings, initialLoad);
                filteredReviews = await filterReviews(null, [], star_ratings, sortings, initialLoad);
            }
        }
        displayReviews(filteredReviews);
    }

    function formatName(name) {
        if (!name) return "Anonymous";
        const parts = name.split(" ");
        return parts.length > 1 ? `${parts[0]} ${parts[1][0]}.` : name;
    }

    function displayReviews(filteredReviews) {
        const reviewContainer = document.getElementById("ytpReviews");
        reviewContainer.innerHTML = "";
        page = 1;
        loadReviews(filteredReviews);
    }

    function decodeHTMLEntities(str) {
      const temp = document.createElement("div");
      temp.innerHTML = str;
      return temp.textContent;
    }

    function loadReviews(filteredReviews) {
        const reviewContainer = document.getElementById("ytpReviews");
        const start = (page - 1) * perPage;
        const end = start + perPage;
        const reviewsToShow = filteredReviews.slice(start, end);

        if (reviewsToShow.length > 0) {
            reviewsToShow.forEach(review => {
                const div = document.createElement("div");
                div.className = "ytp-review-item";

                const fullContent = review.content;
                const decodedContent = decodeHTMLEntities(fullContent);
                //const truncatedContent = fullContent.length > 100 ? fullContent.substring(0, 100) + '...' : fullContent;  
                const truncatedContent = decodedContent.length > 100 ? decodedContent.substring(0, 100) + '...' : decodedContent;    
                const starRating = generateStarRating(review.score);

                div.innerHTML = `
                    <div class="ytp-reviewer-info-container">
                        <div>
                            <div class="ytp-reviewer-name">${formatName(review.user.display_name)}</div>
                            ${review.verified_buyer ? '<div class="ytp-verified-buyer">Verified Buyer</div>' : ''}
                        </div>
                        <div class="ytp-review-date">${new Date(review.created_at).toLocaleDateString()}</div>
                    </div>
                    <div class="ytp-review-content-container">
                        <div class="ytp-review-score">${starRating}</div>
                        <div class="ytp-review-title">${review.title}</div>
                        <div class="ytp-review-content">
                          <div>${truncatedContent}</div>
                            ${fullContent.length > 80 ? '<a href="#" class="see-more">See more</a>' : ''}
                        </div>
                    </div>
                    <div class="ytp-review-date">${new Date(review.created_at).toLocaleDateString()}</div>
                    
                `;
                
                reviewContainer.appendChild(div);

                // Add event listener for "See more" toggle
                const seeMoreLink = div.querySelector(".see-more");
                if (seeMoreLink) {
                    seeMoreLink.addEventListener("click", (event) => {
                        event.preventDefault();
                        const contentElement = div.querySelector(".ytp-review-content > div");
                        if (seeMoreLink.innerText === "See more") {
                            //contentElement.innerText = fullContent;
                            contentElement.innerHTML = fullContent;
                            seeMoreLink.innerText = "See less";
                        } 
                        else {
                            //contentElement.innerText = truncatedContent;
                            contentElement.innerHTML = truncatedContent;
                            seeMoreLink.innerText = "See more";
                        }
                    });
                }
            });
        } else {
            const div = document.createElement("div");
            div.innerHTML = `<p>No result.</p>`;
            reviewContainer.appendChild(div);
        }

        document.getElementById("ytpLoadMore").style.display = end < filteredReviews.length ? "block" : "none";
    }

    function generateStarRating(score) {
        let fullStars = Math.floor(score);
        let decimalPart = score - fullStars;
        let hasHalfStar = decimalPart >= 0.5;
        let totalStars = fullStars + (hasHalfStar ? 1 : 0);
        let emptyStars = 5 - totalStars;
    
        let starsHTML = "";
    
        for (let i = 0; i < fullStars; i++) {
            starsHTML += getStarSVG("full");
        }
    
        if (hasHalfStar) {
            starsHTML += getStarSVG("half");
        }
    
        for (let i = 0; i < emptyStars; i++) {
            starsHTML += getStarSVG("empty");
        }
    
        return starsHTML;
    }
    
    function getStarSVG(type) {
        let starWidth = 28; // Wider star (default was 24)
        let starHeight = 24; // Adjusted height
    
        if (type === "full") {
            return `<svg class="star full-star" width="${starWidth}" height="${starHeight}" viewBox="0 0 30 28" fill="#F6CA51" stroke="#F6CA51" stroke-width="1">
                        <polygon points="15,2 19,10 28,10 21,16 23,26 15,21 7,26 9,16 2,10 11,10"/>
                    </svg>`;
        } else if (type === "half") {
            return `<svg class="star half-star" width="${starWidth}" height="${starHeight}" viewBox="0 0 30 28" stroke="#F6CA51" stroke-width="1">
                        <defs>
                            <linearGradient id="halfGradient">
                                <stop offset="50%" stop-color="#F6CA51"/>
                                <stop offset="50%" stop-color="transparent"/>
                            </linearGradient>
                        </defs>
                        <polygon points="15,2 19,10 28,10 21,16 23,26 15,21 7,26 9,16 2,10 11,10" fill="url(#halfGradient)"/>
                    </svg>`;
        } else {
            return `<svg class="star empty-star" width="${starWidth}" height="${starHeight}" viewBox="0 0 30 28" stroke="#F6CA51" stroke-width="1" fill="transparent">
                        <polygon points="15,2 19,10 28,10 21,16 23,26 15,21 7,26 9,16 2,10 11,10"/>
                    </svg>`;
        }
    }
    
    window.loadMore = function () {
        page++;
        loadReviews(filteredReviews);
    }

    function clearFilters() {
        document.getElementById("ytpProductFilter").value = "all";
        document.getElementById("ytpSort").value = "date";
        document.getElementById("ytpRating").value = "all";
        selectedTopics = [];
        document.querySelectorAll(".topic-button").forEach(button => button.classList.remove("active"));
        applyFilters(null, false);
    }
  
      fetchBottomline();
        fetchTopics();
  
      fetchReviews(true);
  
      document.getElementById("ytpSort")?.addEventListener("change", async () => {
          await applyFilters(null, false);
      });
  
      document.getElementById("ytpRating")?.addEventListener("change", async () => {
          await applyFilters(null, false);
      });
  
      /*document.getElementById("ytpProductFilter").addEventListener("change", async () => {
        await applyFilters(null, false);
      });*/

    document.addEventListener('shopify:section:load', function (e) {
      fetchBottomline();
        fetchTopics();
      fetchReviews(true);
    });
});